var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty has-text-centered"},[_c('div',[_c('div',[_c('EmptyDataIcon')],1),_vm._v(" "),_c('p',[_vm._v("No hay datos para mostrar")])])])}
var staticRenderFns = []

export { render, staticRenderFns }